import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { Calendar } from '@mint-lib/icons';
import { Skeleton, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { ScheduleTableType } from '../../../../types/queryScheduler.js';

const SchedulingCell = ({
  data,
  value,
}: ICellRendererParams<ScheduleTableType>) => {
  if (data?.__isSkeleton) {
    return <Skeleton />;
  }

  if (!value) {
    return null;
  }

  return (
    <div className="flex h-full flex-row items-center gap-1">
      <Calendar className="size-4 shrink-0 fill-icon-primary" />
      <span
        className={cn(
          typographyVariants({ variant: 'bodyShort01' }),
          'capitalize',
        )}
      >
        {value}
      </span>
    </div>
  );
};

export { SchedulingCell };
